import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
	selector: 'app-warning',
	templateUrl: './warning.component.html',
	styleUrls: ['./warning.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class WarningComponent implements OnInit {

	@Input() message = 'Operação realizada com sucesso!';
	@Input() type: string;

	constructor() { }

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/warning/warning.component.ts